import React from 'react';
import PropTypes from 'prop-types';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import RadarItemDetail from 'components/Radar/Details';
import { useQueryString } from 'helpers/effects';

const ScreenRadarDetail = ({ match, routePaths, target }) => {
  const initialFilters = useQueryString();
  return (
    <GridContainer justify="center">
      <GridItem xs={12} sm={6}>
        <RadarItemDetail
          id={match.params.id}
          initialFilters={initialFilters}
          routePaths={routePaths}
          target={target}
        />
      </GridItem>
    </GridContainer>
  );
};

ScreenRadarDetail.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  routePaths: PropTypes.shape({}),
  target: PropTypes.string,
};

ScreenRadarDetail.defaultProps = {
  routePaths: undefined,
  target: undefined,
};

export default ScreenRadarDetail;
